import { Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type RemoveTeamMemberConfirmationModalProps = Pick<
  ConfirmationModalProps,
  "loading" | "open" | "onClose" | "onConfirm"
>;

const RemoveTeamMemberConfirmationModal = (
  props: RemoveTeamMemberConfirmationModalProps
) => (
  <ConfirmationModal
    {...props}
    title="Remove from Team?"
    confirmProps={{ label: "Remove", type: "negative" }}
  >
    <Typography>
      Removing this member from the team means they can no longer access the
      team and associated data.
    </Typography>
  </ConfirmationModal>
);

export default RemoveTeamMemberConfirmationModal;
